<template>
  <div>
    <div
      v-for="(o, key) in options"
      :key="key"
      @click="$emit('select', o)"
      class="mt-1 mb-3 ml-2 pt-2 pb-2 pr-4 pl-4 bg-graylight rounded-lg border d-inline-block w-fit cursor-pointer"
    >
      {{ o.content }}
    </div>
  </div>
</template>

<script>
export default {
  name: "J.L. AIOptions",
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
